// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/auto'
import Vue from 'vue'
import App from './App'

import { store } from './store'

import router from './router'



import "./assets/scss/app.scss";
import socialsharing from 'vue-social-sharing';

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
    created () {
        this.$on('social_shares_close', function (network, url) {
            ga('send', 'event', 'click', 'show', 'Click social: ' + network)
        });
    },
  components: { App },
})
Vue.use(socialsharing);



// WEBPACK FOOTER //
// ./src/main.js